/**
 * 开发环境辅助函数
 * @description 从 userStore 抽取的开发调试工具
 */

import type { UserInfo } from '@/types/auth'
import { PERMISSIONS } from '@/constants'
import { UserRole } from '@/types/auth'

/**
 * 开发环境角色模拟配置
 */
export const DEV_ROLE_PROFILES: Record<UserRole, Partial<UserInfo>> = {
  [UserRole.GUEST]: {
    id: 'dev_guest',
    username: 'guest',
    email: 'guest@mech3d.com',
    nickname: '游客用户',
    role: UserRole.GUEST,
    isVerified: false,
    avatar: '',
  },
  [UserRole.USER]: {
    id: 'dev_user',
    username: 'testuser',
    email: 'test@mech3d.com',
    nickname: '普通用户',
    role: UserRole.USER,
    isVerified: true,
    avatar: '',
  },
  [UserRole.DESIGNER]: {
    id: 'dev_designer',
    username: 'designer',
    email: 'designer@mech3d.com',
    nickname: '设计师用户',
    role: UserRole.DESIGNER,
    isVerified: true,
    avatar: '',
  },
  [UserRole.MANUFACTURER]: {
    id: 'dev_manufacturer',
    username: 'manufacturer',
    email: 'manufacturer@mech3d.com',
    nickname: '制造商用户',
    role: UserRole.MANUFACTURER,
    isVerified: true,
    avatar: '',
  },
  [UserRole.ADMIN]: {
    id: 'dev_admin',
    username: 'admin',
    email: 'admin@mech3d.com',
    nickname: '管理员用户',
    role: UserRole.ADMIN,
    isVerified: true,
    avatar: '',
  },
  [UserRole.SUPER_ADMIN]: {
    id: 'dev_super_admin',
    username: 'superadmin',
    email: 'superadmin@mech3d.com',
    nickname: '超级管理员',
    role: UserRole.SUPER_ADMIN,
    isVerified: true,
    avatar: '',
  },
}

/**
 * 开发环境默认测试路径
 */
export const DEV_TEST_PATHS = [
  '/user/profile',
  '/user/designer',
  '/user/provider',
  '/user/accepted-tasks',
  '/user/earnings-analysis',
  '/user/payment-withdraw',
]

/**
 * 获取测试路径所需权限
 * @param path 路径
 * @returns 所需权限或空字符串
 */
export function getRequiredPermissionForPath(path: string): string {
  if (path.includes('accepted-tasks')) {
    return PERMISSIONS.USER.TASKS.ACCEPT
  }
  if (path.includes('earnings-analysis') || path.includes('payment-withdraw')) {
    return PERMISSIONS.USER.FINANCE.WITHDRAW
  }
  return ''
}
